import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

// URLs list of the APIs to monitor with Datadog.
const TARGET_API_URLS = [
  environment.ldap?.url,
  environment.searchApi?.url,
  environment.myGoogle?.url,
  environment.hrSkillsReferentialV2?.url,
  environment.daTranslationsApi?.url,
  environment.masterSport?.url,
].filter(Boolean);

@Injectable()
export class DatadogErrorInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse && this.isTargetApi(req.url)) {
          // Check if Datadog is properly configured in the current environment
          if (environment.datadog && typeof DD_RUM !== 'undefined') {
            const errorContext = {
              request: {
                url: req.url,
                method: req.method,
              },
              response: {
                status: error.status,
                statusText: error.statusText,
                // Pass the response body in error (serialize if it's an object)
                body: typeof error.error === 'object' ? JSON.stringify(error.error) : error.error,
              },
            };

            DD_RUM.addError(
              new Error(`API Error [${req.method}] ${req.url} - Status ${error.status}`),
              errorContext,
            );
          }
        }
        return throwError(error);
      }),
    );
  }

  private isTargetApi(url: string): boolean {
    if (!url) {
      return false;
    }
    return TARGET_API_URLS.some(apiUrl => url.startsWith(apiUrl));
  }
}
